import { useEffect, useRef } from "react";

// Persistent cinematic backdrop that lives behind every section, so the hero's
// vibe (drifting teal/ember auroras + faint grid) carries through the whole page.
// The grid gently parallaxes with scroll to feel like a scrollable element.
export const AmbientBackground = () => {
  const gridRef = useRef(null);
  const tealRef = useRef(null);
  const emberRef = useRef(null);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const y = window.scrollY;
        if (gridRef.current) gridRef.current.style.transform = `translateY(${y * 0.04}px)`;
        if (tealRef.current) tealRef.current.style.transform = `translateY(${y * -0.06}px)`;
        if (emberRef.current) emberRef.current.style.transform = `translateY(${y * -0.03}px)`;
        raf = 0;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-obsidian" aria-hidden>
      {/* faint parallax grid */}
      <div ref={gridRef} className="ambient-grid absolute inset-[-10%] opacity-60" />

      {/* drifting auroras */}
      <div
        ref={tealRef}
        className="aurora-teal absolute left-[-15%] top-[-10%] h-[70vh] w-[70vh] rounded-full"
      />
      <div
        ref={emberRef}
        className="aurora-ember absolute right-[-12%] top-[55%] h-[65vh] w-[65vh] rounded-full"
      />
      <div className="aurora-teal absolute left-[45%] top-[120%] h-[60vh] w-[60vh] rounded-full opacity-70" />

      {/* vignette for depth */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 90% 60% at 50% 50%, transparent 40%, rgba(3,3,3,0.55) 100%)",
        }}
      />
    </div>
  );
};

export default AmbientBackground;
